import {
  createBrowserRouter
} from "react-router-dom";
import HomePage from "pages/HomePage.tsx";
import MapPage from "pages/MapPage.tsx";
import Error404Page from "pages/Error404Page.tsx";
import CreateEventPage from "pages/profile/events/CreateEventPage.tsx";
import ModifyEventPage from "pages/profile/events/ModifyEventPage.tsx";
import MePage from "pages/profile/me/MePage.tsx";
import MeAccountPage from "pages/profile/me/MeAccountPage.tsx";
import PageWrapper from "components/container/PageWrapper.tsx";
import MeDeletionPage from "pages/profile/me/MeDeletionPage.tsx";
import MePasswordPage from "pages/profile/me/MePasswordPage.tsx";
import MePlansPage from "pages/profile/me/MePlansPage.tsx";
import MeContactUsPage from "pages/profile/me/MeContactUsPage.tsx";
import AdminEventsPage from "pages/admin/AdminEventsPage.tsx";
import AdminUsersPage from "pages/admin/AdminUsersPage.tsx";
import AdminDashboardPage from "pages/admin/AdminDashboardPage.tsx";
import AdminSingleEventPage from "pages/admin/AdminSingleEventPage.tsx";
import AdminSingleUserPage from "pages/admin/AdminSingleUserPage.tsx";
import AdminCreateUserPage from "pages/admin/AdminCreateUserPage.tsx";
import AdminCreateEventPage from "pages/admin/AdminCreateEventPage.tsx";
import AdminNotificationsPage from "pages/admin/AdminNotificationsPage.tsx";
import SwitchProfilePage from "pages/profile/SwitchProfilePage.tsx";
import FeaturedEventsPage from "pages/FeaturedEventsPage.tsx";
import ContactPage from "pages/ContactPage.tsx";
import { TermsPage, PolicyPage } from "pages/LegalContentPage.tsx";


const router = createBrowserRouter([
  {
    path: "/events/:eventHandleOrUuid",
    element: <PageWrapper name="public-single-event" component={MapPage} />
  },
  {
    path: "/profile",
    children: [
      {
        path: "events/create",
        element: <PageWrapper hideNavBar needAuth name="profile-create-event" component={CreateEventPage} />
      },
      {
        path: "events/:eventUuid",
        element: <PageWrapper hideNavBar needAuth name="profile-modify-event" component={ModifyEventPage} />
      },
      {
        path: "me/account",
        element: <PageWrapper hideNavBar needAuth name="profile-me-account" component={MeAccountPage} />
      },
      {
        path: "me/contact",
        element: <PageWrapper hideNavBar needAuth name="profile-me-account" component={MeContactUsPage} />
      },
      {
        path: "me/password",
        element: <PageWrapper hideNavBar needAuth name="profile-me-password" component={MePasswordPage} />
      },
      {
        path: "me/deletion",
        element: <PageWrapper hideNavBar needAuth name="profile-me-deletion" component={MeDeletionPage} />
      },
      {
        path: "me/plans",
        element: <PageWrapper hideNavBar needAuth name="profile-me-plans" component={MePlansPage} />
      },
      {
        path: "me",
        element: <PageWrapper hideNavBar needAuth name="terms" component={MePage} />
      },

      {
        path: "admin",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-dashboard"
                              component={AdminDashboardPage} />
      },
      {
        path: "admin/events",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-events" component={AdminEventsPage} />
      },
      {
        path: "admin/events/create",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-create-event"
                              component={AdminCreateEventPage} />
      },
      {
        path: "admin/events/:eventUuid",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-single-event"
                              component={AdminSingleEventPage} />
      },
      {
        path: "admin/users",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-users" component={AdminUsersPage} />
      },
      {
        path: "admin/users/create",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-create-user"
                              component={AdminCreateUserPage} />
      },
      {
        path: "admin/users/:userId",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-single-user"
                              component={AdminSingleUserPage} />
      },
      {
        path: "admin/notifications",
        element: <PageWrapper hideNavBar needAuth needAdmin name="admin-notifications"
                              component={AdminNotificationsPage} />
      },

      {
        path: "",
        element: <PageWrapper needAuth name="profile" component={SwitchProfilePage} />
      }
    ]
  },
  {
    path: "/map",
    element: <PageWrapper name="map" component={MapPage} />,
    errorElement: <PageWrapper hideNavBar name="404" component={Error404Page} />
  },
  {
    path: "/contact",
    element: <PageWrapper name="contact" component={ContactPage} />,
    errorElement: <PageWrapper hideNavBar name="404" component={Error404Page} />
  },
  {
    path: "/terms",
    element: <PageWrapper name="terms" component={TermsPage}  />,
    errorElement: <PageWrapper hideNavBar name="404" component={Error404Page} />
  },
  {
    path: "/policy",
    element: <PageWrapper name="policy" component={PolicyPage} />,
    errorElement: <PageWrapper hideNavBar name="404" component={Error404Page} />
  },
  {
    path: "/featured",
    element: <PageWrapper name="featured-events" component={FeaturedEventsPage} />,
    errorElement: <PageWrapper hideNavBar name="404" component={Error404Page} />
  },
  {
    path: "/",
    element: <PageWrapper name="index" component={HomePage} />,
    errorElement: <PageWrapper hideNavBar name="404" component={Error404Page} />

  }
]);

export default router;
